
import Vue from 'vue'
import { formatDisplayDateTime } from '@/util/formatters'

import { VDivider, VListItem, VListItemContent } from 'vuetify/lib'
import { userInfo } from '@/util/navUtilities'
import dayjs from 'dayjs'

export default Vue.extend({
  name: 'JcdcUtilityMenuFooter',
  components: {
    VDivider,
    VListItem,
    VListItemContent,
  },
  props: {
    userInfo: { type: Object as () => userInfo, required: true },
  },
  methods: {
    formatDisplayDateTime,
    dayjs,
  },
})
